import React from 'react';

import IconButton from '@material-ui/core/IconButton';
//ICONOS USADOS
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import DeleteIcon from '@material-ui/icons/Delete';

//MATERIAL UI CARD  
import { Card, CardContent } from '@material-ui/core';

//TOOLTIPS
import { OverlayTrigger, Tooltip } from 'react-bootstrap'

const EstablecimientoCard = (props) => {
    const { i,item, permutarArriba, permutarAbajo,quitarEstablecimiento,ultimoEstablecimiento } = props;
    return (
        <div key={i} className="d-flex flex-row justify-content-center align-items-center m-4">
            <div className="d-flex flex-column align-items-center m-2">
                {i > 0 &&
                    <IconButton size="small" color="primary" onClick={() => permutarArriba(i)}>
                        <ExpandLessIcon />
                    </IconButton>}
                <div className="row justify-content-center">
                    <h4>Prioridad</h4>
                    <IconButton size="small" disabled={true} style={{ color: "white", backgroundColor: "#1BC5BD", marginLeft: 10, marginRight: 10, paddingLeft: 10, paddingRight: 10, fontSize: 11, width: 23, height: 23 }}>
                        {i + 1}
                    </IconButton>
                </div>
                {i < ultimoEstablecimiento - 1 &&
                    <IconButton size="small" color="primary" onClick={() => permutarAbajo(i)} >
                        <ExpandMoreIcon />
                    </IconButton>}
            </div>
            <Card className="col-10 ml-3" style={{ backgroundColor: "#f7f7f7" }}>
                <CardContent>
                    <div className="row justify-content-between align-items-center">
                        <div className="col-12">
                            <h5>{item.establecimiento}</h5>
                            <div className="d-none d-sm-block">
                                <h6 className=""><b>Dirección:</b> {item.direccion}</h6>
                                <div className="d-flex flex-row">
                                    <div className="d-flex flex-row justify-content-between">
                                        <small className=""><b>Departamento:</b> {item.departamento} </small>
                                        <small className=""><b>Localidad:</b> {item.localidad} </small>
                                        {/*<p className="mr-4 ml-4">Email: {item.email}</p>*/}
                                    </div>
                                </div>
                            </div>
                            <h6 className="d-block d-sm-none"><b>Dirección:</b> {item.direccion}</h6>
                            <small className="d-block d-sm-none"><b>Departamento:</b> {item.departamento}</small>
                            <small className="d-block d-sm-none"><b>Localidad:</b> {item.localidad}</small>
                            {/*<p className="d-block d-sm-none">{item.email}</p>*/}
                        </div>
                    </div>
                    <div className="row justify-content-between align-items-center">
                        <div className="col-9 col-sm-10">
                            <p>Turno: {item.turno} <b>{!!item.curso && item.curso.toUpperCase() === 'PLURISALA' ? ' - PLURISALA' : ''}</b></p>
                            <div className="d-none d-sm-block">
                                <p className="mt-1 mb-1"><b>¿Tiene hermana/o aquí? </b> {item.hermano || item.hermanoId > 0 ? "SI" : "NO"}</p>
                                <p className="mt-1 mb-1"><b>¿Tiene familiar trabajando aquí? </b> {item.familiar || item.familiarId > 0 ? "SI" : "NO"}</p>
                                <p><b>¿Tiene una inscripión vinculada aquí? </b> {item.codigoInscripcionVinculada ? "SI" : "NO"}</p>
                            </div>
                            <div className="d-none d-sm-block">
                                <div className="d-flex flex-row">
                                    <p className="mr-4"><b>VACANTES:</b> {item.vacantes}</p>
                                    {/*<p className="ml-4"><b>LISTA DE ESPERA:</b> {item.listaEspera}</p>*/}
                                </div>
                            </div>
                            <p className="d-block d-sm-none"><b>VACANTES:</b> {item.vacantes}</p>
                            {/*<p className="d-block d-sm-none"><b>LISTA DE ESPERA:</b> {item.listaEspera}</p>*/}
                        </div>
                        <div className="justify-content-center align-items-end col-3 col-sm-2">
                            <OverlayTrigger placement="left" delay={{ show: 250, hide: 400 }} overlay={<Tooltip>Quitar este establecimiento</Tooltip>}>
                                <IconButton onClick={() => quitarEstablecimiento(item)}>
                                    <DeleteIcon fontSize="large" style={{color: "#F64E60"}} />
                                </IconButton>
                            </OverlayTrigger>
                        </div>
                    </div>
                </CardContent>
            </Card>
        </div>
    )
}

export default EstablecimientoCard;